import { ReactComponent } from "./calendar_line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const CalendarLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default CalendarLineIcon;
